import SignupVerify from "../../../../jsx/pages/Connector/SignupVerify";

const SignupVerifyWrapper = function () {
  return <SignupVerify />;
};

export default constore(SignupVerifyWrapper);
